import { useEffect } from "react"

export const useGetFirstURL = () => {
  useEffect(() => {
    if (!sessionStorage.getItem("firstURL")) {
      sessionStorage.setItem("firstURL", document.URL)
    }
  }, [])
}
